"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadBox = void 0;
var upload_box_component_1 = require("./upload-box.component");
Object.defineProperty(exports, "UploadBox", { enumerable: true, get: function () { return upload_box_component_1.UploadBox; } });
